import { render, staticRenderFns } from "./SiderBar.vue?vue&type=template&id=a674ac60&scoped=true&"
import script from "./SiderBar.vue?vue&type=script&lang=js&"
export * from "./SiderBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a674ac60",
  null
  
)

export default component.exports